import React from "react";
import styles from "../../static/css/pages.module.css";
import InputDiv from "../../components/form/input/input_div";
import {connect} from "react-redux";
import RegisterUnbind from "./status/unbind";
import RegisterUnregister from "./status/unregister";
import ieSvg from "../../components/icons/ieSvg";

class ProfileMain extends React.Component {
  componentDidMount() {
    ieSvg();
    document.title = "Настройки профиля | Самозанятые";
  }

  render() {
    if (this.props.data.items) {
      return (
        <React.Fragment>
          <div className={styles.article}>
            Ваши данные замаскированы в целях безопасности.<br/>
            Чтобы изменить информацию, обратитесь к специалисту банка.
          </div>
          <div className="l-grid">
            <div className="l-grid__item_10">
              {this.props.data?.items?.data?.secondName ?
                <InputDiv label="Фамилия Имя Отчество"
                          value={`${this.props.data.items.data.surname} ${this.props.data.items.data.name} ${this.props.data.items.data.secondName}`}/>
                :
                <InputDiv label="Фамилия Имя"
                          value={`${this.props.data.items.data.surname} ${this.props.data.items.data.name}`}/>
              }
              <InputDiv label="ИНН" value={this.props.data.items.data.inn}/>
            </div>
          </div>
          <div>
            <RegisterUnbind partnerName={this.props.data.items.data.partnerName}/>
            <RegisterUnregister/>
          </div>
          <div className={styles.article}/>
        </React.Fragment>
      )
    }
    else {
      return (
        <React.Fragment>
          <div className={styles.article}>&nbsp;</div>
          <div className={styles.article}>&nbsp;</div>
          <div className={`${styles.loadingEl} ${styles.loadingInner}`}>
            <div className={styles.loader}/>
            {this.props.waiting}
          </div>
          <div className={styles.article}>&nbsp;</div>
          <div className={styles.article}>&nbsp;</div>
          <div className={styles.article}>&nbsp;</div>
        </React.Fragment>
      )
    }
  }
}

const mapStateToProps = state => ({data: state.clientInfo});

export default connect(mapStateToProps)(ProfileMain);